import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BusinessServices.css';

const GrowingStars = () => {
  const navigate = useNavigate();

  const cards = [
    {
      id: 'personality',
      icon: '🌟',
      title: 'Personality & Cosmic Blueprint',
      subtitle: "Understand your child's natural strengths, emotional patterns, and unique cosmic signature.",
      features: [
        'Natal chart overview',
        'Temperament & emotional blueprint',
        'Learning & communication style',
        "Strengths & potential challenges",
        'Parent–child compatibility insights'
      ]
    },
    {
      id: 'growth',
      icon: '📈',
      title: 'Growth, Learning & Potential',
      subtitle: 'Discover talents, learning abilities, and long-term growth potential.',
      features: [
        'Skill & talent indicators',
        'Ideal learning environments',
        'Growth phases & development timing',
        'Early vocation tendencies',
        'Guidance for hobbies & activities'
      ]
    },
    {
      id: 'health',
      icon: '💚',
      title: 'Health, Energy & Wellness',
      subtitle: "Understand your child's energy flow, emotional wellbeing, and natural rhythms.",
      features: [
        'Vitality & energy cycle analysis',
        'Emotional sensitivity maps',
        'Stress triggers & calming tools',
        'Mind–body tendencies',
        'Wellness timing & guidance'
      ]
    },
    {
      id: 'relationships',
      icon: '🤝',
      title: 'Emotional & Relationship Harmony',
      subtitle: "Strengthen emotional bonds and support your child's relationships with loved ones.",
      features: [
        'Bonding & attachment style',
        'Social & friendship patterns',
        'Family dynamics overview',
        'Communication tendencies',
        'Tools for harmony & confidence'
      ]
    }
  ];

  return (
    <section className="bg-sand py-8">
      <div className="w-full px-6">
        {/* Title and intro are rendered at the page level (src/pages/GrowingStars.js) to avoid duplication */}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {cards.map((c) => (
            <div key={c.id} className="bg-bone/95 rounded-xl p-8 border border-indigoDeep/10 hover:border-indigoDeep/20 transition-transform duration-300 hover:scale-105 shadow-sm">
              <div className="text-4xl mb-4">{c.icon}</div>
              <h3 className="font-serif text-2xl mb-2 text-indigoDeep">{c.title}</h3>
              <p className="text-grayWarm text-sm mb-6">{c.subtitle}</p>

              <div className="space-y-3">
                <p className="text-xs uppercase tracking-widest text-grayWarm/70 font-semibold">INCLUDES:</p>
                <ul className="space-y-2">
                  {c.features.map((f, i) => (
                    <li key={i} className="flex items-start text-sm text-grayWarm">
                      <span className="text-goldSoft mr-3 mt-1">✦</span>
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <button
                onClick={() => navigate('/booking')}
                className="w-full mt-8 bg-gradient-to-r from-goldSoft to-goldHover hover:from-goldHover hover:to-goldSoft text-indigoDeep font-semibold py-3 rounded-lg transition-shadow duration-300 shadow-sm">
                Learn More
              </button>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center bg-bone/95 rounded-xl p-12 border border-indigoDeep/10">
          <p className="text-indigoDeep text-xl mb-8 font-serif">Support your child's growth with compassionate, practical astrological guidance.</p>
          <button
            onClick={() => navigate('/booking')}
            className="bg-gradient-to-r from-goldSoft to-goldHover hover:from-goldHover hover:to-goldSoft text-indigoDeep font-bold py-4 px-12 rounded-lg transition-all duration-300 text-lg">
            📅 Book a Growing Stars Reading
          </button>
        </div>
      </div>
    </section>
  );
};

export default GrowingStars;
